module.exports = __webpack_public_path__ + "static/WingsOverTheWest.b2a012af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/AirtourMaps/WingsOverTheWest.jpg
// module id = 431
// module chunks = 122553044697643